import { useRef } from 'react';

// This unused legacy hook previously connected to hardcoded staging with an
// unrelated cookie. Browser WebSocket cannot attach API-KEY. Keep it disabled
// until a backend-scoped authenticated adapter exists; no token in a URL.
const EMPTY_MESSAGES = Object.freeze([]);
export function useOdooWebSocket() {
  const ws = useRef(null);
  return { ws, messages: EMPTY_MESSAGES, status: 'disabled' };
}
